import Route from '@ember/routing/route';
import { get } from '@ember/object';
import { isEmpty } from '@ember/utils';
import RSVP from 'rsvp';
import { service } from '@ember/service';

export default Route.extend({
  fundsService: service(),
  store: service(),
  storeCache: service(),

  beforeModel() {
    return this.fundsService.confirmValidFundToken();
  },

  model(params) {
    let storeCache = this.storeCache;
    let promise = RSVP.hash({
      fund: this.store.findRecord('admin/fund', params.id),
      userFundsForFund: this.store.query('admin/user-fund', {
        filter: { fund_id: params.id },
      }),
      indexUsers: storeCache.indexSingleBy('admin/user', 'id'),
    });
    return promise.then((data) => {
      let fund = data.fund;
      return {
        record: fund,
        users: data.userFundsForFund.map(
          (userFund) => data.indexUsers[userFund.userId],
        ),
      };
    });
  },
});
